import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import FamilyTreeBuilder from "./components/FamilyTreeBuilder";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { useAuth } from "./contexts/AuthContext";

const App: React.FC = () => {
  const { currentUser, logout, setCurrentUser } = useAuth();
  
  const handleLogout = async () => {
    console.log('Initiating logout...');
    console.log('Current auth state:', currentUser);
    
    try {
      const success = await logout();
      console.log('Logout result:', success);
      
      if (!success) {
        console.error('Logout failed');
        // Optionally show error to user
      } else {
        console.log('Logout successful, updating UI');
        setCurrentUser(null); // Force update the UI
        console.log('Post-logout auth state:', currentUser);
      }
    } catch (error) {
      console.error('Logout error:', error);
      // Optionally show error to user
    }
    
    console.log('LocalStorage after logout:', localStorage.getItem('currentUser'));
  };
  
  return (
    <div className="app">
      {/* Navigation Bar */}
      <nav className="app-header p-4">
        <div className="max-w-6xl mx-auto flex justify-between items-center">
          <div className="text-2xl font-bold tracking-tight flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
            <h1>Family Tree</h1>
          </div>
          {currentUser && (
            <div className="flex items-center">
              <button 
                onClick={handleLogout}
                className="md-button md-button-filled px-6 py-3 rounded-full transition-all duration-200 hover:shadow-md"
              >
                <span className="flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                  </svg>
                  Logout
                </span>
              </button>
            </div>
          )}
        </div>
      </nav>
      
      {/* Application Routes */}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <ProtectedRoute>
            <FamilyTreeBuilder />
          </ProtectedRoute>
        } />
      </Routes>
    </div>
  );
};

export default App;
